import type {
  createTokens as tamaguiCreateTokens,
  createVariables as tamaguiCreateVariables,
} from '@tamagui/core';
import { createVariable, isVariable } from '@tamagui/core';

export const createTokens: typeof tamaguiCreateTokens = (tokens) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return createVariables(tokens) as any;
};

const cache = new WeakMap();

// Adapted from https://github.com/tamagui/tamagui/blob/master/packages/web/src/createVariables.ts#L21
// Tamagui's css variables look like `--space-1`, but this naming clashes with css vars from
// old bricks. This modified version of createVariables creates css vars that look like `--space-2x`,
// where `2x` is the name of a design system token
export const createVariables: typeof tamaguiCreateVariables = (tokens, parentPath = '') => {
  if (cache.has(tokens)) return tokens;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const res: any = {};
  for (const keyIn in tokens) {
    const val = tokens[keyIn];
    const isPrefixed = keyIn[0] === '$';
    const keyWithPrefix = isPrefixed ? keyIn : `$${keyIn}`;
    const key = isPrefixed ? keyWithPrefix.slice(1) : keyIn;
    if (isVariable(val)) {
      res[key] = val;
      continue;
    }
    if (val && typeof val === 'object') {
      // recurse
      res[key] = createVariables(tokens[key], keyIn);
      continue;
    }
    // Bare-integer keys (from Novo.sp/sz) would produce CSS vars like --space-12,
    // which collide with old bricks' array-index-based --space-12. Prefix with 'bn-'
    // so they become --space-bn-12 instead, while $12 still works as the token key.
    const cssKey = /^\d+$/.test(keyIn) ? `bn-${keyIn}` : keyIn;
    const name = `${parentPath}-${cssKey}`;
    const finalValue = isVariable(val) ? val : createVariable({ val, name, key: keyWithPrefix });
    res[key] = finalValue;
  }

  cache.set(res, true);
  return res;
};
